import AcSection from "./modules/ac-section";
import { initPointers } from "./modules/ac-pointer";
import { initAdminColumnsGlobalBootstrap } from "./helpers/admin-columns";
var $ = require("jquery");
initAdminColumnsGlobalBootstrap();
window.ac_pointers = initPointers;
$(document).ready(function () {
    initPointers();
    document.querySelectorAll('.ac-section').forEach(function (el) {
        new AcSection(el);
    });
});
